<template>
  <!--成品附加费-->
  <div>
    <s-pageheader title="成品附加费" />
    <ak-model-filter-card model="finishSurcharge" @search="search" @reset="reset" :perPage="30" />
    <!--附加费-->
    <ak-model-tree
      :treeSpan="4"
      model="finishSurcharge"
      treeModel="finishWorkShop"
      parentKey="parentNode"
      pointerToTree="proportion"
      treeTitle="车间检索"
      @selected="getTree"
      :action="edit"
      :modelTableProps="modelTableProps"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader/PageHeader'
import editSurcharge from '@/core/components/editSurcharge'
import { mapState } from 'vuex'
import store from './../../store'
import Bus from '../../assets/js/eventBus'

export default {
  components: {
    's-pageheader': PageHeader
  },
  data () {
    return {
      // key: JSON.stringify(store.state.finishSurchargeKey), // 默认选中的节点ID
      edit: {
        // 覆盖model的action
        create: {},
        edit: {
          title: '编辑附加费',
          component: editSurcharge
        }
      },
      modelTableProps: {
        perPage: 30,
        page: 1,
        filters: {}
      }
    }
  },
  computed: {
    ...mapState(['user'])
    // url () {
    //   console.log(window.location.search, 's')
    //   return window.location.search
    // }
  },
  mounted () {
    // this.getSurcharge()
  },
  methods: {
    search (filters) {
      this.$set(this.modelTableProps, 'filters', filters)
      this.$set(this.modelTableProps, 'page', 1)
      console.log(this.modelTableProps)
    },
    reset () {
      this.$set(this.modelTableProps, 'filters', {})
      this.$set(this.modelTableProps, 'page', 1)
      Bus.$emit('reset', '')
    },
    // 获取成品附加费
    async getSurcharge () {
      // let res = await this.$modelAjax.getDta('surcharge', {
      //   params: {
      //     where: { type: 'finish' }
      //   }
      // }).catch(e => {})
    },
    // 监听树节点选中状态
    getTree (obj) {
      // 根据选中的节点判断新建按钮是否显示
      if (
        obj.length === 1 &&
        obj[0].record.type === 'ratio' &&
        store.state.user && store.state.user.authority.finishSurcharge.create
      ) {
        this.edit.create = {
          title: '添加附加费',
          text: '新建',
          buttonType: 'primary',
          classify: 'finish',
          icon: 'plus',
          type: 'list',
          proportion: obj[0].key,
          modelId: obj[0].parentNode.key,
          workShop: obj[0].record.workShop.objectId,
          component: editSurcharge
        }
      } else {
        this.edit.create = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .node-icon:before {
  content: none !important;
}
</style>
